<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.deviceinspectstandard_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="projectForm" slot-scope="scope">
        <el-select
          v-model="form.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          clearable
          @change="(value) => querySelect(value,1)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value) => querySelect(value,2)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="deviceTypeIdForm" slot-scope="scope">
        <el-select
          :value="form.deviceTypeId"
          placeholder="请选择设备类型"
          clearable
          style="width: 100%;"
        >
          <el-option :value="form.deviceTypeId" show-all-levels :label="form.typeName">
            <el-tree
              node-key="id"
              :data="treeFormData"
              :props="treeProps"
              :load="typeLazyLoadTree"
              lazy
              @node-click="typeNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot="deviceTypeIdSearch" slot-scope="scope">
        <el-select
          :value="query.deviceTypeId"
          placeholder="请选择设备类型"
          style="width: 100%;"
        >
          <el-option :value="query.deviceTypeId" show-all-levels :label="query.typeName">
            <el-tree
              node-key="id"
              :data="treeSearchData"
              :props="treeProps"
              :load="typeLazyLoadTree"
              lazy
              @node-click="typeSearchNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/crmedical/device/deviceinspectstandard";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {getTree} from "@/api/crmedical/device/devicetype";

  export default {
    data() {
      return {
        deptNameFlag: true,
        deptIdFlag: false,
        areaNameFlag: true,
        areaIdFlag: false,
        typeNameFlag: true,
        typeIdFlag: false,
        treeFormDeptData: [],
        treeFormAreaData: [],
        treeFormData:[],
        treeSearchData:[],
        typeTreeFlag: true,
        projectList: [],
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        treeProps: {
          //标题
          label: 'name',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'name',
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: true,
          searchMenuSpan: 6,
          columnBtn: false,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              display: false,
            },
            {
              label: "项目名称",
              prop: "project",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              formslot: true,
              search: true,
              searchslot:true,
              addDisplay: true,
              editDisplay: false,
              hide: true,
            },
            {
              label: "项目名称",
              prop: "projectName",
              disabled: true,
              addDisplay: false,
              editDisplay: true,
              hide: true,
            },
            {
              label: "设备类型",
              prop: "deviceTypeId",
              rules: [{
                required: true,
                message: "请选择设备类型",
                trigger: "change"
              }] ,
              search:true,
              formslot: true,
              searchslot: true,
              addDisplay: true,
              editDisplay: false,
              hide: true,
            },
            {
              label: "设备类型",
              prop: "typeName",
              disabled: true,
              addDisplay: false,
              editDisplay: true,
            },
            {
              label: "标准名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入标准名称",
                trigger: "change"
              }],
              search: true,
              maxlength: 20,
              showWordLimit: true,
            },
            {
              label: "巡检标准",
              prop: "content",
              type: 'textarea',
              rules: [{
                required: true,
                message: "请输入巡检标准",
                trigger: "change"
              }],
              maxlength: 200,
              showWordLimit: true,
              overHidden: true,
              span: 24
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.deviceinspectstandard_add, false),
          viewBtn: this.vaildData(this.permission.deviceinspectstandard_view, false),
          delBtn: this.vaildData(this.permission.deviceinspectstandard_delete, false),
          editBtn: this.vaildData(this.permission.deviceinspectstandard_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      typeLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        let projectId;
        if(this.form.projectId){
          projectId = this.form.projectId;
        } else {
          projectId = this.query.projectId;
        }
        let isArray = false;
        getTree({ id: id, projectId: projectId}).then(({ data }) => {
          console.log("getTree====>",data);
          if (data instanceof Array ) {
            isArray = true;
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          if(!isArray){
            data = [];
          }
          resolve(data);
        });
      },
      typeNodeTreeClick(node) {
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.form.typeName = nodeTitle;
        this.form.deviceTypeId = nodeId;
        this.$forceUpdate();
      },
      typeSearchNodeTreeClick(node) {
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.query.typeName = nodeTitle;
        this.query.deviceTypeId = nodeId;
        this.$forceUpdate();
      },
      querySelect(value,type){
        if(type === 1){
          this.form.projectId = value;
          this.form.typeName = '';
          this.form.deviceTypeId = '';
        } else if(type === 2){
          this.query.projectId = value;
          this.query.typeName = '';
          this.query.deviceTypeId = '';
        }
        getTree({ id: 0, projectId: value}).then(({ data }) => {
          if (data instanceof Array ) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          if(type === 1){
            this.treeFormData = data;
          } else if(type === 2){
            this.treeSearchData = data;
          } else {
            this.treeFormData = data;
            this.treeSearchData = data;
          }
        });
        this.$forceUpdate();
      },
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        this.treeFormData = [];
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query.name = '';
        this.query.typeName = '';
        this.query.deviceTypeId = '';
        this.onLoad();
      },
      searchChange(params,done) {
        this.query.name = params.name;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          });
        }else {
          getProjectList().then((data)=>{
            this.projectList = data.data;
            if(this.projectList.length > 0){
              this.query.projectId = this.projectList[0].id;
              this.query.project = this.projectList[0].name;
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            }
          });
        }
      }
    }
  };
</script>

<style>
</style>
